// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ChangeCodePopup_dialog_UDKwO"};